import { createSlice } from "@reduxjs/toolkit";
import { PAGE_SIZES } from "../../../constants";

const initialState: any = {
  list: {
    total: 0,
    data: null,
    loading: null,
    success: null,
    error: null,
    filters: {
      selectedPage: 1,
      selectedPageSize: PAGE_SIZES[0],
      isInterestedBy: false,
    },
  },
};

const opportunity = createSlice({
  name: "opportunity",
  initialState,
  reducers: {
    setVendorOpportunityListDataLoading: (state, action) => {
      state.list = {
        ...state.list,
        loading: action.payload,
      };
    },
    setVendorOpportunityData: (state, action) => {
      state.list = {
        ...state.list,
        data: action.payload.data,
        total: action.payload.total,
        loading: false,
        error: "",
        success: true,
        filters: {
          ...state.list.filters,
          ...action.payload.filters,
        },
      };
    },
    setProjectListError: (state, action) => {
      state.list = {
        ...state.list,
        total: 0,
        data: null,
        loading: false,
        success: false,
        error: action.payload,
      };
    },
    resetVendorOpportunityList: (state) => {
      return { ...initialState };
    },
  },
});

export const {
  setVendorOpportunityData,
  setVendorOpportunityListDataLoading,
  setProjectListError,
  resetVendorOpportunityList,
} = opportunity.actions;

export default opportunity.reducer;
